export enum UserAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Upload = 'upload',
  NSearch = 'nsearch',
}

export enum LogEntities {
  Person = 'person',
  Vehicle = 'vehicle',
  File_Upload = 'file_upload',
  Transaction = 'transaction',
  Topic = 'topic',
  Enterprise = 'enterprise',
  Location = 'location',
  Sensor = 'sensor',
  Relation = 'relation',
  NSearch = 'nsearch',
}
